<template>
	<div class="container-login-box">
		<div class="login-box">

			<div class="login-logo">
				<img  :src="logo" alt="Boleto Web" style="margin-bottom:20px;">
				<span style="font-size:20px; color:#fff; font-weight:bold; margin:0; padding:0; display:block">Boleto Web</span>
			</div>

			<div class="login-box-body">
				<p class="login-box-msg">Informe suas credenciais de acesso</p>

				<form @submit.prevent="onSubmitLogin">
					<div class="form-group has-feedback">
						<input type="usuario" name="username" v-model="username" class="form-control" placeholder="Login">
						<span class="fa fa-user form-control-feedback"></span>
					</div>
					<div class="form-group has-feedback">
						<input type="password" name="password" v-model="password" class="form-control" placeholder="Senha">
						<span class="fa fa-lock form-control-feedback"></span>
					</div>

					<div class="row">
						<div class="col-xs-4 col-xs-offset-8">
							<button type="submit" v-bind:class="'btn btn-default btn-block btn-flat ' + loading">Entrar</button>
						</div>
						<!-- errors -->
						<div v-if="response" class="col-xs-12 text-red"><p class="vertical-5p lead">{{response}}</p></div>
					</div>
				</form>
				<!-- /.login-box-body -->
			</div>
			<!-- /.login-box -->
		</div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'Login',
	data (router) {
		return {
			logo: `${this.$store.state.serverURI}/images/logo-premium.png`,
			section: 'Login',
			loading: '',
			username: '',
			password: '',
			response: ''
		}
	},
	mounted () {
		this.$nextTick(() => { this.$refs.username.focus() });
	},
	methods: {
		onSubmitLogin () {
			const { username, password } = this
			this.toggleLoading()
			this.resetResponse()
			this.$store.commit('TOGGLE_LOADING')

			/* Fazendo chamada a API para Autenticar */
			axios.post(`${this.$store.state.serverURI}/api/login`, { username, password }, this.$store.getters.getHeader)
				.then(response => {
					this.toggleLoading()
					var data = response.data

					if (data.access_token) {
						var token = data.access_token
						this.$store.commit('SET_TOKEN', token) // Setando o token no estado do vuex (store)

						/* Buscando dados do usuário através do token recuperado */
						axios.get(`${this.$store.state.serverURI}/api/usuario/getUserCurrent`, this.$store.getters.getHeaderAuth)
							.then(resp => {
								var userCurrent = resp.data
								this.setUsuarioAtual(userCurrent);
								if (window.localStorage) {
									window.localStorage.setItem('token', token)
								}
							}).then(a => {
								let route = '/'
								if (localStorage.getItem('route') && localStorage.getItem('route') != 'undefined') {
									let path = localStorage.getItem('route').split('/', 3)
									route = path.join('/')
									if (!route) {
										route = '/'
									}
								}
								localStorage.removeItem('route')
								console.log(route);
								this.$router.push(data.redirect ? data.redirect : route)
							})
							.catch(error => {
								console.log(error)
							})

					}
				})
				.catch(error => {
					this.$store.commit('TOGGLE_LOADING')
					console.log(error)

					this.response = 'Ocorreu uma falha na autenticação!'
					this.toggleLoading()
				})
		},

		toggleLoading () {
			this.loading = this.loading === '' ? 'loading' : ''
		},
		resetResponse () {
			this.response = ''
		}
	}
}
</script>

<style>
	html,
	body,
	.container-table {
		height: 100%;
		background-color: #333 !important;
	}
	.container-table {
		display: table;
		color: white;
	}

	.container-login-box {
		overflow: hidden;
	}

	.logo {
		width: 20em;
		padding: 3em;
	}

	.login-logo, .register-logo {
		font-size: 20px;
		text-align: center;
		margin-bottom: 20px;
		font-weight: 300;
	}
</style>



// WEBPACK FOOTER //
// Login.vue?6b712fe5